module.exports = __webpack_public_path__ + "img/zhewan6.fd81c25a.jpg";